import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { PageLoading } from "../components/PageLoading";
import { useDrokAccess } from "./use-drok-access";

/** /onboarding creates an agent, so only people who manage agents see it; employees go to the app. */
export function DrokOnboardingGate({ children }: { children: ReactNode }) {
  const access = useDrokAccess();
  if (access === "loading") return <PageLoading />;
  if (access === "employee") return <Navigate to="/app" replace />;
  return children;
}
